import { Component, Input } from '@angular/core';
import * as _ from 'lodash';
import {ClientsService} from "../../../models/clients/clients.service";
import {NgbModal, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {DebtsService} from "../../../models/debts/debts.service";
import {AccountStatusesModel} from "../../../models/debts/debts.model";

@Component({
    selector: 'account-modal',
    templateUrl: 'account-modal.template.html',
    styleUrls: ['account-modal.component.css']
})

export class AccountModalComponent {
    @Input() client_id: any;
    public processingAccountStatuses = <AccountStatusesModel[]> [];
    public oldDebtAccounts: any = [];
    public debtAccount: Array<any>;
    public debtAccountId: any;
    public newDebtAccount: string;

    constructor(
        private clientsService: ClientsService,
        public activeModal: NgbActiveModal,
        private debtService: DebtsService
    ) {

    }

    ngOnInit() {
        this.getProcessingStatuses();
        this.loadDebtAccounts();
    }

    public addNewDebtAccount() {
        this.debtService.addDebtStatus({name: this.newDebtAccount, funded:this.debtService.accountStatusTypes.FUNDED})
            .subscribe((res) => {
                this.processingAccountStatuses.push(res.data);
            });
        // this.getProcessingStatuses();
        this.newDebtAccount = null;
    }

    public saveDebtAccount() {
        this.activeModal.close(this.debtAccount);
    }

    saveDebtAccountById() {
        this.activeModal.close(this.debtAccountId);
    }

    private getProcessingStatuses() {
        this.debtService.getAccountStatuses({funded: this.debtService.accountStatusTypes.FUNDED})
            .subscribe((res) => {
                this.processingAccountStatuses = res.data;
            });
    }

    private loadDebtAccounts() {
        let debt_list: any = [];
        this.debtService.getListByClient(this.client_id)
            .subscribe((res) => {
                this.oldDebtAccounts = [];
                for (let debt of res.data) {
                    if (debt.closed_by > 0) continue;
                    this.oldDebtAccounts.push(debt);
                }
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/client-status/account-modal/account-modal.component.ts